module.exports = __webpack_public_path__ + "static/media/pay-cash.b4d4a84a.svg";